import React from 'react';
import PreviewContainer from './PreviewContainer';
import PublicAgentAuthForm from '@/components/agent/public/PublicAgentAuthForm';

interface SplashPagePreviewProps {
  agent: any;
  organization: any;
  previewSettings?: {
    title?: string;
    subtitle?: string;
    buttonText?: string;
  };
  previewFields?: any[];
  onRefresh?: () => void;
}

const SplashPagePreview: React.FC<SplashPagePreviewProps> = ({
  agent,
  organization,
  previewSettings,
  previewFields,
  onRefresh
}) => {
  // Create a preview version of the agent with current form values and fields
  const previewAgent = {
    ...agent,
    splash_page_title: previewSettings?.title || agent?.splash_page_title,
    splash_page_subtitle: previewSettings?.subtitle || agent?.splash_page_subtitle,
    start_button_text: previewSettings?.buttonText || agent?.start_button_text || "Start Chat",
    // Override form fields with preview fields if available
    form_fields: previewFields || agent?.form_fields || []
  };

  const handlePreviewSubmit = async () => {
    // No-op for preview
    return Promise.resolve();
  };

  return (
    <PreviewContainer title="Splash Page Preview" className="h-fit" onRefresh={onRefresh}>
      <div className="w-full relative">
        <div className="pointer-events-none relative">
          <PublicAgentAuthForm
            onSubmit={handlePreviewSubmit}
            agent={previewAgent}
            organization={organization}
            isEmbedded={false}
          />
          {/* Overlay to prevent interactions */}
          <div className="absolute inset-0 bg-transparent z-10"></div>
        </div>
      </div>
    </PreviewContainer>
  );
};

export default SplashPagePreview; 